export const loginDutch = {
  lang: 'nl',
  data: {
    LOGIN: {
      MESSAGE: 'Support panel',
      EMAIL: 'E-mail',
      PASSWORD: 'Wachtwoord',
      LOGIN_FAILED: 'Inloggen niet gelukt',
      SENDING_MAGIC_LINK: 'We sturen je een eenmalige loginlink...',
      SENT_MAGIC_LINK: 'We hebben je een eenmalige loginlink gestuurd, check je e-mail!',
      MAGIC_LINK_FAILURE: 'Er is iets mis gegaan met het sturen van de loginlink. Probeer het nog eens.',
      LOGGING_IN: 'Bezig met inloggen...',
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/main/authentication/login/i18n/nl.ts